import * as React from 'react';
import { Or } from 'source/app/domain/Or';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import Glyphicon from 'source/app/presentation/Shared/Glyphicon/Glyphicon';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
const style = require('./Chevron.css');

const Chevron = ({
	isUp,
	reduceOpacity
}: {
	isUp: boolean;
	reduceOpacity?: boolean;
}) => {
	const icon = isUp ? EGlyphicon['chevron-up'] : EGlyphicon['chevron-down'];
	const opacity = Or(reduceOpacity, false) ? 0.3 : 1;

	return (
		<span
			className={style.chevron}
			{...Style(`chevron_${opacity}`, {
				opacity: Or(reduceOpacity, false) ? 0.3 : 1
			})}
		>
			<Glyphicon icon={icon} />
		</span>
	);
};

export default Chevron;
